import React from "react";
import Button from "components/button";
import Stack from "@mui/material/Stack";
import { useTheme } from "styled-components";
import { StyledHeaderSection } from "../style";
import Typography from "@mui/material/Typography";

function HeaderSection({ disableButton = false, onClickAddNewAmenity }) {
  const theme = useTheme();

  return (
    <StyledHeaderSection>
      <Stack spacing={1}>
        <Typography>
          Provide one image for each amenity that we will add to the property
          map.
        </Typography>
      </Stack>

      <Button
        title='Add New Amenity'
        bgColor={theme.colors.green}
        onClick={onClickAddNewAmenity}
        disabled={disableButton}
      />
    </StyledHeaderSection>
  );
}

export default HeaderSection;
